const playProducts = [
  {
    id: 1,
    title: "CuddleRide Cub 🏍️",
    handle: "cuddleride-cub",
    defaultVariantId: "51836002173209",
    variants: [
      { name: "Motorcycle", id: "51836002173209", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9c578b9d-b363-4cb1-81f6-e2fc774e6fa4.jpg?v=1767806191" },
      { name: "Octopus", id: "51836002042137", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_e357cc61-ad79-4272-a443-63853c4c05f7.png?v=1767806191" },
      { name: "Police", id: "51836002074905", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_b5ae7860-8fce-49e8-93d3-c55c933a575e.png?v=1768852306" },
      { name: "Ice Cream Scoops", id: "51836002107673", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_38fe2bda-6036-40ae-94e5-3c16cc8a6563.jpg?v=1768852306" }
    ]
  },
  {
    id: 2,
    title: "Zein Educational Toy 🧩",
    handle: "zein",
    variants: [
      { name: "Standard", id: "52288206995737", price: 17.97, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_d99c426e-4d8e-414b-8037-753985caafd2.png?v=1746732508" }
    ]
  },
  {
    id: 3,
    title: "Abjad Learning Set 📚",
    handle: "abjad",
    variants: [
      { name: "Brown", id: "52288207323417", price: 77.97, comparePrice: 94.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_f5f3cae2-1516-46f6-88cf-69855b80207f.jpg?v=1777207485" }
    ]
  },
  {
    id: 4,
    title: "BearMunch Teething Mitt 🐻",
    handle: "bearmunch-teething-mitt",
    variants: [
      { name: "Brown", id: "47223127769369", price: 5.99, comparePrice: 9.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/brown.jpg?v=1759163809" },
      { name: "Aqua", id: "47223127802137", price: 5.99, comparePrice: 9.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/green.jpg?v=1759163809" },
      { name: "Pink", id: "47223127834905", price: 5.99, comparePrice: 9.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/brown.jpg?v=1759163809" },
      { name: "Light Blue", id: "51444760510745", price: 5.99, comparePrice: 9.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/blue_9c96ee1a-0e74-41fe-b321-3c3ddd121447.jpg?v=1759163809" }
    ]
  },
  {
    id: 5,
    title: "TwinkleTyke Portable Baby Nightlight ✨",
    handle: "twinkletyke-portable-baby-nightlight",
    variants: [
      { name: "Bunny", id: "47542584967449", price: 7.98, comparePrice: 11.97, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/image00004.jpg?v=1702069330" },
      { name: "Bear", id: "47542585000217", price: 7.98, comparePrice: 11.97, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/image00005.jpg?v=1702069329" }
    ]
  }
];

let playStockSynced = false;

async function syncPlayShopifyStock() {
  for (const product of playProducts) {
    try {
      const res = await fetch(`/products/${product.handle}.js`);
      if (!res.ok) continue;

      const data = await res.json();

      product.variants.forEach(variant => {
        const liveVariant = data.variants.find(v => String(v.id) === String(variant.id));
        if (liveVariant) {
          variant.inStock = liveVariant.available;
          variant.price = liveVariant.price / 100;
          variant.comparePrice = liveVariant.compare_at_price ? liveVariant.compare_at_price / 100 : null;
        }
      });
    } catch (error) {
      console.warn("Stock/price sync failed:", product.title);
    }
  }
  playStockSynced = true;
}

function getPlaySavePercentage(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return null;
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

function getPlayDefaultVariant(product) {
  if (product.defaultVariantId) {
    const chosen = product.variants.find(v => String(v.id) === String(product.defaultVariantId));
    if (chosen && chosen.inStock) return chosen;
  }
  return product.variants.find(v => v.inStock) || product.variants[0];
}

function renderPlayProducts() {
  const grid = document.getElementById("playGrid");
  if (!grid) return;

  grid.innerHTML = "";

  playProducts.forEach(product => {
    const firstVariant = getPlayDefaultVariant(product);
    const displayImage = product.defaultImage || firstVariant.image;
    const savePercent = getPlaySavePercentage(firstVariant.price, firstVariant.comparePrice);

    const card = document.createElement("article");
    card.className = "play-card";

    let dropdownOptions = "";

    product.variants.forEach(variant => {
      const selected = String(variant.id) === String(firstVariant.id) ? "selected" : "";
      const soldOutClass = !variant.inStock ? "sold-out-option" : "";

      dropdownOptions += `
        <option
          value="${variant.id}"
          data-price="${variant.price}"
          data-compare="${variant.comparePrice || ""}"
          data-image="${variant.image}"
          data-title="${product.title}"
          data-instock="${variant.inStock}"
          class="${soldOutClass}"
          ${selected}>
          ${variant.name}
        </option>
      `;
    });

    card.innerHTML = `
      <div class="play-card-image-container">
        ${savePercent ? `<span class="sale-badge">SAVE ${savePercent}%</span>` : ""}

        <img src="${displayImage}" alt="${product.title}" class="play-card-image" loading="lazy">

        <div class="image-overlay">
          <a href="/products/${product.handle}" class="view-details-btn">
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/>
            </svg>
            <span>View Details</span>
          </a>
        </div>

        <button class="image-cart-btn add-to-cart-mobile ${!firstVariant.inStock ? "sold-out-mobile" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </button>

        ${!firstVariant.inStock ? `<div class="mobile-sold-out">Sold Out</div>` : ""}
      </div>

      <div class="play-card-info">
        <h3 class="play-card-title">${product.title}</h3>

        <div class="variant-selector">
          <select class="variant-dropdown ${!firstVariant.inStock ? "selected-sold-out" : ""}">
            ${dropdownOptions}
          </select>
        </div>

        <div class="play-card-price">
          <span class="current-price">$${firstVariant.price.toFixed(2)}</span>
          ${firstVariant.comparePrice ? `<span class="compare-price">$${firstVariant.comparePrice.toFixed(2)}</span>` : ""}
        </div>

        <button class="add-to-cart-btn add-to-cart-desktop ${!firstVariant.inStock ? "sold-out" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          <span>${firstVariant.inStock ? "Add to Cart" : "Sold Out"}</span>
        </button>
      </div>
    `;

    grid.appendChild(card);
  });

  attachPlayEventListeners();
}

function attachPlayEventListeners() {
  document.querySelectorAll(".variant-dropdown").forEach(dropdown => {
    dropdown.addEventListener("change", function () {
      const card = this.closest(".play-card");
      const option = this.options[this.selectedIndex];

      const variantId = option.value;
      const price = parseFloat(option.dataset.price);
      const compare = option.dataset.compare ? parseFloat(option.dataset.compare) : null;
      const image = option.dataset.image;
      const productTitle = option.dataset.title;
      const inStock = option.dataset.instock === "true";

      const imageEl = card.querySelector(".play-card-image");
      const priceEl = card.querySelector(".current-price");
      const compareEl = card.querySelector(".compare-price");
      const desktopBtn = card.querySelector(".add-to-cart-desktop");
      const mobileBtn = card.querySelector(".add-to-cart-mobile");
      const imageContainer = card.querySelector(".play-card-image-container");

      imageEl.src = image;
      priceEl.textContent = `$${price.toFixed(2)}`;

      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = `$${compare.toFixed(2)}`;
          compareEl.style.display = "inline";
        } else {
          compareEl.style.display = "none";
        }
      }

      desktopBtn.dataset.variantId = variantId;
      desktopBtn.dataset.price = price;
      mobileBtn.dataset.variantId = variantId;
      mobileBtn.dataset.price = price;

      const existingBadge = card.querySelector(".mobile-sold-out");

      if (inStock) {
        this.classList.remove("selected-sold-out");

        desktopBtn.disabled = false;
        desktopBtn.classList.remove("sold-out");
        desktopBtn.querySelector("span").textContent = "Add to Cart";

        mobileBtn.disabled = false;
        mobileBtn.classList.remove("sold-out-mobile");

        if (existingBadge) existingBadge.remove();
      } else {
        this.classList.add("selected-sold-out");

        desktopBtn.disabled = true;
        desktopBtn.classList.add("sold-out");
        desktopBtn.querySelector("span").textContent = "Sold Out";

        mobileBtn.disabled = true;
        mobileBtn.classList.add("sold-out-mobile");

        if (!existingBadge) {
          const badge = document.createElement("div");
          badge.className = "mobile-sold-out";
          badge.textContent = "Sold Out";
          imageContainer.appendChild(badge);
        }
      }
    });
  });

  document.querySelectorAll(".add-to-cart-desktop").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });

  document.querySelectorAll(".add-to-cart-mobile").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  renderPlayProducts();
  syncPlayShopifyStock().then(function () {
    renderPlayProducts();
  });
});